import React from 'react';
import styles from './CugBadge.module.css';

interface CugBadgeProps {
  mobile: string;
  isCUG: boolean;
}

const CugBadge: React.FC<CugBadgeProps> = ({ mobile, isCUG }) => {
  return (
    <span className={styles.mobileContainer}>
      {mobile}
      {isCUG && <span className={styles.cugBadge}>CUG</span>}
    </span>
  );
};

export default CugBadge;
